export default __webpack_public_path__ + "static/media/btn-more.fa4b7f42.webp";